import { render, staticRenderFns } from "./Changeinfo.vue?vue&type=template&id=3ade50c8&"
import script from "./Changeinfo.vue?vue&type=script&lang=js&"
export * from "./Changeinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports